module.exports = __webpack_public_path__ + "img/bg-sorteo-2024.1a0ac52d.jpg";